const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        page: {
          title: "Attendance indicators",
          subtitleAll: "Overview of every conversation handled by the operation.",
          subtitleOwn: "Your attendance indicators.",
          period: {
            label: "Period",
            today: "Today",
            last7: "Last 7 days",
            last30: "Last 30 days",
            month: "This month",
            custom: "Custom",
            from: "From",
            to: "To",
          },
          filters: {
            queue: "Queue",
            allQueues: "All queues",
            attendant: "Attendant",
            allAttendants: "All attendants",
          },
          errors: {
            invalidDates: "Enter valid dates.",
            endBeforeStart: "The end date must be on or after the start date.",
            tooLong: "The maximum period is 366 days.",
          },
          cards: {
            conversations: "conversations measured",
            open: { label: "In attendance now", hint: "Tickets open at this moment, regardless of the period." },
            pending: { label: "Waiting now", hint: "Tickets waiting in the queue for someone to accept them, right now." },
            unanswered: { label: "Unanswered", hint: "Tickets of the period where the customer wrote and nobody has answered yet." },
            created: { label: "Conversations started", hint: "Tickets created in the period. A conversation reopened in the same ticket is not counted again. Groups are excluded." },
            closed: { label: "Resolved", hint: "Tickets closed within the period." },
            firstResponse: { label: "First response (avg.)", hint: "Time from the customer's first message to our first message. Automatic agent replies count. Tickets we started are excluded." },
            handling: { label: "Handling time (approx.)", hint: "From ticket creation to the last update of tickets resolved in the period. It is an approximation: any change after resolution alters the number." },
            ratings: "ratings",
            rating: { label: "Average rating", hint: "Mean grade (1 to 5) given by customers on conversations resolved in the period. Only customers who answered the survey count." },
            ratingRate: { label: "Survey response rate", hint: "Of the conversations resolved in the period where a rating was requested, how many customers answered." },
            newContacts: { label: "New contacts", hint: "Contacts registered in the period (groups excluded)." },
          },
          charts: {
            byHour: "Conversations started by hour of day",
            ratings: "Ratings received",
            closeReasons: "Closing reasons",
            perDay: "Conversations started per day",
            perQueue: "By queue",
            perAttendant: "By attendant",
          },
          table: {
            rating: "Rating",
            attendant: "Attendant",
            created: "Started",
            closed: "Resolved",
            firstResponse: "First response (avg.)",
          },
          noReason: "No reason",
          noRatings: "No ratings in this period.",
          noQueue: "No queue",
          noAttendant: "No attendant (in queue)",
          empty: "No conversations in this period.",
        },
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          default: "Default",
          botEnabled: "Rose agent active on this connection",
          ignoreGroups: "Ignore WhatsApp groups",
        },
        hours: {
          enabled: "Set business hours",
          help: "Outside hours, Rose keeps answering and says the team replies during business hours. Without Rose, the customer gets the notice below (once every 12 hours).",
          timezone: "Time zone",
          closed: "Closed",
          holidays: "Holidays and days off",
          holidaysHelp: "One date per line, as YYYY-MM-DD (e.g. 2026-12-25).",
          message: "Out-of-hours notice",
          messageHelp: "Sent to customers who write outside business hours. Leave empty to send nothing. Accepts {{name}}.",
          days: { 0: "Sunday", 1: "Monday", 2: "Tuesday", 3: "Wednesday", 4: "Thursday", 5: "Friday", 6: "Saturday" },
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        noPhone: "No phone",
        lidHint: "LID: WhatsApp internal id, used when the phone is not revealed.",
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      hermes: {
        handoffReason: {
          cliente: "Rose: the customer asked for a person",
          modelo: "Rose: the agent handed over to the team",
          erro: "Rose: the agent failed and handed over",
          ventana: "Rose: reply window ran out",
          hostilidade: "Rose: upset customer, take care",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        lidOnlyHint: "The field above holds the LID, not a phone. Enter the real phone with country and area code to identify the contact.",
        lidHint: "WhatsApp internal id, kept alongside the phone.",
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        botHeader: "Bot",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
          peek: "Peek conversation",
        },
        peek: {
          subtitle: "Peeking (read-only, the customer does not see you opened it)",
          close: "Close",
          empty: "No messages",
          loading: "Loading…",
          latest: "Showing the latest messages",
          customer: "Customer",
          team: "Bot / team",
          media: "[media]",
          deleted: "deleted message",
          noQueue: "No queue",
          botActive: "Bot active",
          waiting: "Waiting",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      lab: {
        title: "Rose Lab",
        hint: "Simulated customers talk to Rose in a sandbox (nothing is sent over WhatsApp and no real conversation is changed). Each scenario is graded by fixed criteria: whether it handed off, the reason, what the answer contains and its length. Run before and after changing the agent.",
        scenarios: "Scenarios",
        results: "Results",
        builtin: "default",
        noRuns: "No test run yet.",
        pickOne: "Select at least one scenario.",
        turnsCount: "{{count}} customer message(s)",
        running: "Running… {{done}} of {{total}} scenarios",
        summary: "{{passed}} of {{total}} scenarios passed",
        customer: "Customer",
        agent: "Rose",
        handedOff: "Handed off to the team",
        scenarioSaved: "Scenario saved.",
        scenarioDeleted: "Scenario deleted.",
        deleteTitle: "Delete scenario",
        deleteMessage: "This scenario will be removed. Past results stay saved.",
        status: { pass: "Passed", fail: "Failed", error: "Error" },
        handoff: { any: "Handoff does not matter", required: "Must hand off", forbidden: "Must not hand off" },
        hours: { open: "Hours: open", closed: "Hours: closed (simulated)", real: "Connection's real hours" },
        reason: { cliente: "Customer asked", modelo: "Agent decided", erro: "Error", ventana: "Timed out", hostilidade: "Hostility" },
        buttons: { new: "New scenario", run: "Run selected", duplicate: "Duplicate", save: "Save", cancel: "Cancel" },
        modal: {
          titleNew: "New scenario",
          titleEdit: "Edit scenario",
          name: "Name",
          turns: "Customer messages",
          turnsHelp: "One per line (up to 6). If Rose hands off, the rest are not sent.",
          hours: "Simulated business hours",
          hoursHelp: "Sent to Rose along with the message.",
          expectTitle: "What to expect from Rose",
          handoff: "Handoff to the team",
          reasonsHelp: "Accepted reasons if it hands off (empty = any):",
          mustContain: "The answer must contain",
          mustNotContain: "The answer must not contain",
          termsHelp: "One term per line; ignores case and accents.",
          minReplies: "Min. replies",
          maxReplies: "Max. replies",
          maxReplyChars: "Max. characters",
          timeout: "Wait (s)",
        },
      },
      campaigns: {
        title: "Campaigns",
        hint: "Bulk sends with a random pause between messages, an hourly cap and a time window. Only message people who agreed to be contacted.",
        empty: "No campaigns yet. Create the first one to get started.",
        optOutNotice: "To stop receiving messages, reply STOP.",
        buttons: {
          add: "New campaign",
          details: "Details",
          start: "Start",
          pause: "Pause",
          resume: "Resume",
          cancel: "Cancel campaign",
          delete: "Delete",
          close: "Close",
          review: "Review",
          keepDraft: "Keep as draft",
        },
        table: {
          name: "Name",
          status: "Status",
          progress: "Progress",
          sent: "Sent",
          remaining: "Remaining",
          actions: "Actions",
        },
        status: {
          draft: "Draft",
          running: "Sending",
          paused: "Paused",
          completed: "Completed",
          canceled: "Canceled",
        },
        recipientStatus: {
          pending: "Queued",
          sent: "Sent",
          failed: "Failed",
          invalid: "No WhatsApp",
          skipped: "Skipped",
        },
        toasts: {
          started: "Campaign started.",
          deleted: "Campaign deleted.",
        },
        confirm: {
          cancel: {
            title: "Cancel campaign",
            message: "Messages not sent yet will be discarded. What was already sent cannot be undone.",
          },
          delete: {
            title: "Delete campaign",
            message: "The sending history of this campaign will be erased.",
          },
        },
        details: {
          estimate: "estimated time left: {{time}} (time window not included)",
          finished: "finished",
          message: "Message",
          settings: "{{min}} to {{max}} s between messages · up to {{hourly}} per hour",
          window: "only from {{start}} to {{end}}",
          started: "Started",
          finishedAt: "Finished",
          filter: "Show",
          all: "All",
          name: "Name",
          number: "Number",
          status: "Status",
          sentAt: "Sent at",
          more: "Load more",
        },
        modal: {
          title: "New campaign",
          reviewTitle: "Review before sending",
          name: "Campaign name",
          connection: "Connection that will send",
          connectionOffline: "This connection is not connected right now. Sending only starts when it is.",
          audience: "Who receives it",
          audienceAll: "All contacts (except groups and people who opted out)",
          audienceContacts: "Pick contacts",
          audienceTag: "Contacts with a tag",
          chooseTag: "Choose the tag",
          noTags: "No tags created. Create them in Contacts > Tags.",
          audienceNumbers: "Paste a list of numbers",
          searchContacts: "Search contacts",
          noContacts: "No contacts found",
          numbersHint: "One per line: just the number, or name;number. Numbers without a country code are treated as Brazilian (55).",
          message: "Message",
          messageHint: "Use [[firstName]] or [[name]] and variations like {Hello|Hi|Hey}",
          preview: "Preview (example)",
          optOutNotice: "Add a stop notice (\"reply STOP\") at the end of the message",
          pace: "Sending pace",
          minDelay: "Min pause (s)",
          maxDelay: "Max pause (s)",
          hourlyLimit: "Max per hour",
          paceHint: "The pause between messages is drawn between the minimum and the maximum (minimum allowed: {{min}} s). A slower pace lowers the risk of the number being blocked.",
          useWindow: "Send only during certain hours",
          windowStart: "From",
          windowEnd: "Until",
          scheduledAt: "Start at (optional)",
          scheduledHint: "Empty: starts as soon as you start it.",
        },
        review: {
          ready: "{{count}} recipients ready to receive.",
          optOut: "{{count}} skipped because they asked not to receive messages.",
          invalid: "{{count}} lines/contacts with an invalid number were skipped.",
          duplicates: "{{count}} duplicates were skipped.",
          estimate: "Estimated time: {{time}} (time window not included).",
          warning: "Once started, messages already sent cannot be undone. You can pause or cancel at any time.",
        },
        optOutBadge: "Does not want campaigns",
        optOutOn: "Mark as not wanting campaigns",
        optOutOff: "Allow campaigns again",
      },
      tags: {
        title: "Tags",
        manage: "Tags",
        filter: "Tag",
        filterAll: "All",
        contactTitle: "Contact tags",
        select: "Tags",
        noneCreated: "No tags yet. An administrator creates them in Contacts > Tags.",
        newName: "New tag",
        editName: "Tag name",
        empty: "No tags yet.",
        contactsCount: "{{count}} contact",
        contactsCount_plural: "{{count}} contacts",
        confirmDelete: "Delete the tag \"{{name}}\"? It will be removed from all contacts.",
        toasts: {
          deleted: "Tag deleted.",
        },
        buttons: {
          add: "Add",
          save: "Save",
          cancelEdit: "Cancel editing",
          close: "Close",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          campaigns: "Campaigns",
          lab: "Lab",
          schedules: "Scheduled",
          supervisor: "Supervisor",
          protocols: "Protocols",
          funnel: "Funnel",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
          darkMode: "Dark mode",
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      funnel: {
        title: "Sales funnel",
        new: "New opportunity",
        search: "Search opportunity or contact",
        owner: "Owner",
        allOwners: "Everyone",
        noOwner: "No owner",
        emptyStage: "No opportunities in this stage.",
        truncated: "Showing the {{total}} most recent. Use search to see the rest.",
        menu: "Options",
        moveTo: "Move to {{stage}}",
        delete: "Delete",
        deleted: "Opportunity deleted.",
        confirmDeleteTitle: "Delete opportunity",
        confirmDeleteMessage: "The opportunity and its tasks will be removed. The ticket and the contact are not affected.",
        kind: {"open": "In progress", "won": "Won", "lost": "Lost"},
        summary: {
          open: "{{total}} open",
          openValue: "Open: {{total}}",
          won: "{{total}} won",
          wonValue: "Won: {{total}}",
          rate: "Win rate: {{total}}%",
          noRate: "Win rate: no data",
        },
        card: {"overdue": "{{total}} overdue", "tasks": "{{total}} task(s)"},
        alerts: {
          button: "Alerts ({{total}})",
          taskOverdue: "Overdue task",
          stale: "Stalled",
          days: "{{total}} day(s) in stage",
        },
        dialog: {
          newTitle: "New opportunity",
          editTitle: "Opportunity",
          title: "Title",
          contact: "Contact",
          contactHint: "Type at least 3 letters of the name or number",
          pickContact: "Pick the opportunity's contact.",
          value: "Value (BRL)",
          stage: "Initial stage",
          firstStage: "First stage",
          owner: "Owner",
          me: "Me",
          notes: "Notes",
          openTicket: "Open ticket",
          saved: "Opportunity saved.",
          cancel: "Cancel",
          save: "Save",
        },
        tasks: {
          title: "Tasks",
          empty: "No tasks. Record the next step so the deadline is not missed.",
          new: "New task",
          due: "Due",
          add: "Add",
          remove: "Remove task",
          noDue: "No due date",
          overdue: "Overdue",
        },
        stages: {
          button: "Stages",
          title: "Funnel stages",
          hint: "\"In progress\" stages can warn when an opportunity sits too long. \"Won\" and \"lost\" stages close the opportunity.",
          name: "Name",
          color: "Color",
          kind: "Type",
          staleDays: "Alert after (days)",
          save: "Save",
          saved: "Stage saved.",
          up: "Move up",
          down: "Move down",
          remove: "Delete stage",
          add: "Add stage",
          newName: "New stage",
          close: "Close",
        },
      },
      protocols: {
        title: "Protocols and ratings",
        export: "Export CSV",
        truncated: "The export was limited to the {{rows}} most recent rows. Use the filters to narrow it down.",
        summary: { total: "Closed", rated: "Rated", average: "Average rating", low: "Ratings 1 and 2" },
        hintAdmin: "Closed conversations, with protocol, reason and customer rating. The closing date is approximate (last update of the conversation). Ratings 1 and 2 are highlighted for follow-up.",
        hintOwn: "Your closed conversations, with protocol, reason and customer rating.",
        search: "Search protocol or contact",
        filters: {
          from: "Closed from",
          to: "To",
          rating: "Rating",
          anyRating: "Any",
          reason: "Reason",
          allReasons: "All",
          noReason: "No reason",
          queue: "Queue",
          allQueues: "All",
          noQueue: "No queue",
          attendant: "Attendant",
          allAttendants: "Everyone",
          connection: "Connection",
          allConnections: "All",
        },
        ratingFilter: { rated: "Rated", unrated: "Not rated", low: "Low (1 and 2)", "5": "Rating 5", "4": "Rating 4", "3": "Rating 3", "2": "Rating 2", "1": "Rating 1" },
        table: { protocol: "Protocol", contact: "Contact", attendant: "Attendant", queue: "Queue", reason: "Reason", rating: "Rating", closedAt: "Closed at", actions: "Actions" },
        empty: "No closed conversations match these filters.",
        openTicket: "Open conversation",
        perPage: "Per page",
      },
      supervisor: {
        title: "Supervisor",
        hint: "Open and waiting conversations, from the most idle to the most recent. Tick the ones you want to handle and use the bulk actions (up to {{max}} at a time). These actions never send anything to the customer.",
        search: "Search contact or message",
        summary: { open: "In progress", pending: "Waiting" },
        status: { open: "In progress", pending: "Waiting" },
        filters: {
          status: "Status",
          allStatus: "All",
          queue: "Queue",
          allQueues: "All",
          noQueue: "No queue",
          attendant: "Attendant",
          allAttendants: "Everyone",
          noAttendant: "No attendant",
          connection: "Connection",
          allConnections: "All",
          idle: "Idle for",
          anyIdle: "Any time",
          idleAtLeast: "At least {{time}}",
          unread: "Only with unread",
        },
        table: {
          contact: "Contact",
          lastMessage: "Last message",
          status: "Status",
          attendant: "Attendant",
          queue: "Queue",
          idle: "Idle for",
          actions: "Actions",
        },
        nobody: "Nobody",
        empty: "No conversations match these filters.",
        openTicket: "Open conversation",
        selectPage: "Select all on this page",
        selected: "{{total}} selected (max {{max}})",
        clear: "Clear selection",
        limit: "Limit of {{max}} conversations at a time.",
        perPage: "Per page",
        result: "{{done}} done, {{skipped}} skipped, {{failed}} failed.",
        transfer: {
          user: "Destination attendant",
          noUser: "None (back to the queue)",
          queue: "Destination queue",
          keepQueue: "Keep current queue",
          help: "With an attendant, the conversation becomes \"In progress\". With a queue only, it goes back to \"Waiting\" in that queue.",
        },
        actions: {
          transfer: {
            button: "Transfer",
            title: "Transfer {{total}} conversation(s)",
            description: "Choose the attendant and/or the queue. Each conversation gets an internal note recording the transfer.",
            confirm: "Transfer",
          },
          unassign: {
            button: "Back to queue",
            title: "Send {{total}} conversation(s) back to the queue",
            description: "Conversations lose their attendant and go back to \"Waiting\", in the same queue.",
            confirm: "Send back",
          },
          close: {
            button: "Resolve",
            title: "Resolve {{total}} conversation(s)",
            description: "Conversations are closed with no farewell message and no rating request to the customer. If they write again, they return to the queue as usual.",
            confirm: "Resolve",
          },
          markRead: {
            button: "Mark as read",
            title: "Mark {{total}} conversation(s) as read",
            description: "Clears the unread counters in the panel. No read receipt is sent to the customer.",
            confirm: "Mark as read",
          },
        },
      },
      schedules: {
        title: "Scheduled messages",
        hintAdmin: "Every message scheduled by the team. Pending messages can be canceled; failed ones can be retried. To schedule, use the clock inside a conversation.",
        hintOwn: "Messages you scheduled. To schedule, use the clock inside a conversation.",
        search: "Search by contact, number or text",
        filters: {
          status: "Status",
          all: "All",
          connection: "Connection",
          allConnections: "All",
          createdBy: "Scheduled by",
          everyone: "Everyone",
          from: "From",
          to: "To",
        },
        table: {
          contact: "Contact",
          message: "Message",
          sendAt: "Send at",
          status: "Status",
          connection: "Connection",
          createdBy: "Scheduled by",
          actions: "Actions",
        },
        empty: "No scheduled messages match these filters.",
        openTicket: "Open conversation",
        retry: "Retry",
        cancel: "Cancel sending",
        confirmCancelTitle: "Cancel this scheduled message?",
        canceled: "Scheduled message canceled.",
        retried: "Message queued for sending.",
      },
      schedule: {
        title:"Schedule message",
        message: "Message",
        when: "Send at",
        repeat: "Repeat",
        hint: "The message goes out through this conversation's connection. If the connection is offline the system retries up to 3 times.",
        saved: "Message scheduled.",
        list: "Scheduled in this conversation",
        empty: "No scheduled messages.",
        close: "Close",
        save: "Schedule",
        status: {
          pending: "Pending",
          sent: "Sent",
          failed: "Failed",
          canceled: "Canceled",
        },
        recurrence: {
          none: "Once",
          daily: "Every day",
          weekly: "Every week",
          monthly: "Every month",
        },
        followUpEnabled: "Automatic follow-up when the customer stops replying",
        followUpAfter: "Minutes of silence (min. 30)",
        followUpMax: "Max follow-ups (1 to 3)",
        followUpMessage: "Follow-up message",
        followUpHelp: "Use {{name}} for the name. Only sent during business hours, on conversations without the bot, and stops when the customer replies or asks to opt out. Empty uses the default text.",
      },
      quality: {
        closeTitle: "Close conversation",
        reason: "Closing reason",
        reasonRequired: "Required: choose a reason to close.",
        reasonOptional: "Optional: choose a reason or close without one.",
        reasonNone: "No reason",
        confirm: "Close",
        cancel: "Cancel",
        notes: "Internal notes",
        notesHint: "Visible to the team only. The customer does not receive them.",
        notesPlaceholder: "Write a note...",
        notesAdd: "Add",
        notesEmpty: "No notes yet.",
        notesClose: "Close",
        protocol: "Protocol",
        rating: "Rating",
        settingsTitle: "Service quality",
        requireReason: "Require a reason when closing",
        reasonsTitle: "Closing reasons",
        reasonName: "New reason",
        reasonAdd: "Add",
        reasonInactive: "inactive",
        reasonHide: "Deactivate",
        reasonShow: "Reactivate",
        reasonDelete: "Delete",
        ratingEnabled: "Ask for a rating (1 to 5) when closing",
        ratingMessage: "Rating message",
        ratingHelp: "Use {{protocol}} for the protocol and {{name}} for the name. Empty uses the default text.",
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            botOn: "Bot on",
            botOff: "Bot off",
            botTurnOff: "Turn the bot off and take over",
            botTurnOn: "Turn the bot on for this ticket",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_FUNNEL_TITLE: "Enter the opportunity title (up to 120 characters).",
        ERR_FUNNEL_VALUE: "Enter a valid value, zero or more.",
        ERR_FUNNEL_NOTES: "Notes can have up to 2000 characters.",
        ERR_FUNNEL_DUE: "Enter a valid date and time.",
        ERR_FUNNEL_COLOR: "Pick a valid color.",
        ERR_FUNNEL_KIND: "Invalid stage type.",
        ERR_FUNNEL_STALE_DAYS: "Enter between 1 and 365 days, or leave it empty.",
        ERR_FUNNEL_STAGE_NAME: "Enter the stage name (up to 60 characters).",
        ERR_FUNNEL_STAGE_NOT_FOUND: "Stage not found.",
        ERR_FUNNEL_STAGE_HAS_OPPORTUNITIES: "Move the opportunities out of this stage before deleting it.",
        ERR_FUNNEL_LAST_OPEN_STAGE: "The funnel needs at least one in-progress stage.",
        ERR_FUNNEL_REORDER: "Could not reorder the stages. Refresh the page.",
        ERR_OPPORTUNITY_NOT_FOUND: "Opportunity not found.",
        ERR_TASK_NOT_FOUND: "Task not found.",
        ERR_TASK_TITLE: "Enter the task title (up to 160 characters).",
        ERR_TASK_DONE: "Invalid task completion value.",
        ERR_SCHEDULE_INVALID_BODY: "Write the message (up to 4000 characters).",
        ERR_SCHEDULE_INVALID_DATE: "Enter a valid date and time.",
        ERR_SCHEDULE_PAST: "Pick a time at least 1 minute ahead.",
        ERR_SCHEDULE_TOO_FAR: "Scheduling is limited to 1 year ahead.",
        ERR_SCHEDULE_INVALID_RECURRENCE: "Invalid repeat option.",
        ERR_SCHEDULE_NOT_FOUND: "Schedule not found.",
        ERR_SCHEDULE_NOT_PENDING: "Only pending messages can be canceled.",
        ERR_SCHEDULE_NOT_FAILED: "Only failed messages can be retried.",
        ERR_BULK_EMPTY: "Select at least one conversation.",
        ERR_BULK_LIMIT: "Select at most 200 conversations at a time.",
        ERR_BULK_INVALID_ACTION: "Invalid action.",
        ERR_BULK_TARGET_REQUIRED: "Choose an attendant or a destination queue.",
        ERR_BULK_INVALID_TARGET: "Destination attendant or queue not found.",
        ERR_CLOSE_REASON_REQUIRED: "Choose the closing reason.",
        ERR_CLOSE_REASON_INVALID: "Invalid or deactivated closing reason.",
        ERR_CLOSE_REASON_INVALID_NAME: "Enter a name of up to 80 characters.",
        ERR_CLOSE_REASON_DUPLICATED: "A reason with this name already exists.",
        ERR_CLOSE_REASON_NOT_FOUND: "Reason not found.",
        ERR_NOTE_INVALID: "Write the note (up to 2000 characters).",
        ERR_NOTE_NOT_FOUND: "Note not found.",
        ERR_TAG_NOT_FOUND: "Tag not found.",
        ERR_TAG_NAME_IN_USE: "A tag with this name already exists.",
        ERR_TAG_INVALID_NAME: "Enter the tag name (up to 40 characters).",
        ERR_TAG_TOO_MANY: "Limit of 20 tags per contact.",
        ERR_CAMPAIGN_NOT_FOUND: "Campaign not found.",
        ERR_CAMPAIGN_INVALID_STATE: "This action is not possible in the campaign's current state.",
        ERR_CAMPAIGN_CONNECTION_BUSY: "Another campaign is already sending through this connection. Pause or finish it first.",
        ERR_CAMPAIGN_NO_RECIPIENTS: "No valid recipients for this campaign.",
        ERR_CAMPAIGN_NO_RECIPIENTS_OPT_OUT: "All chosen contacts asked not to receive campaigns.",
        ERR_LAB_INVALID_NAME: "Enter a name for the scenario.",
        ERR_LAB_INVALID_TURNS: "Enter 1 to 6 customer messages (up to 500 characters each).",
        ERR_LAB_INVALID_EXPECT: "Check the scenario criteria.",
        ERR_LAB_NOT_FOUND: "Lab record not found.",
        ERR_LAB_RUN_BUSY: "A test is already running.",
        ERR_LAB_NO_SCENARIOS: "No scenario selected.",
        ERR_HERMES_NOT_CONFIGURED: "The Rose integration is not configured (HERMES_WEBHOOK_URL).",
        ERR_BUSINESS_HOURS_INVALID: "Invalid business hours.",
        ERR_BUSINESS_HOURS_TIMEZONE: "Invalid time zone.",
        ERR_BUSINESS_HOURS_TIME: "Invalid times: use HH:MM with opening before closing.",
        ERR_BUSINESS_HOURS_HOLIDAY: "Invalid holidays: use real dates as YYYY-MM-DD.",
        ERR_BUSINESS_HOURS_NO_DAYS: "Select at least one working day.",
        ERR_CAMPAIGN_TOO_MANY_RECIPIENTS: "Too many recipients for one campaign (maximum 5000).",
        ERR_CAMPAIGN_INVALID_NAME: "Enter a campaign name.",
        ERR_CAMPAIGN_INVALID_MESSAGE: "Enter the message (up to 3000 characters).",
        ERR_CAMPAIGN_INVALID_CONNECTION: "Invalid connection.",
        ERR_CAMPAIGN_INVALID_SETTINGS: "Check the sending pace: pauses or hourly cap out of range.",
        ERR_CAMPAIGN_DELAY_TOO_LOW: "The minimum pause between messages is 15 seconds.",
        ERR_CAMPAIGN_INVALID_WINDOW: "Check the hours: fill in a different start and end (HH:MM).",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_NO_TICKET_ACCESS: "You don't have access to this ticket.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
      },
    },
  },
};

export { messages };
